import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { BreadCrumb, CustomTable } from "../../../../../../components";
import { MenuType, useColumn } from "../../utils";
import { useTranslation } from "react-i18next";
import { FloatFilter } from "../../../../../../components/filtersDrawer/floatFilter";
import { icons } from "../../../../../../utils/icons";
import { useStyles } from "./styles";
import { useTimeConfigContext } from "../../context";
import { useEffect, useLayoutEffect, useState } from "react";
import { levelServiceFetch } from "../../../../../../utils/constants/callService";
import { returnQuery } from "../../../../../../utils/methods/returnQuery";
import { RowTable } from "../../utils/types";
import { BaseMenuClick } from "../../../../../../components/baseMenu";
import { emitEvent } from "../../../../../../hooks/emitter";
import { Events } from "../../../../../../hooks/emitter/types";
import { useNavigate } from "react-router-dom";
import { PathsEnum } from "../../../../../../utils/crud/paths";
import { Types } from "../../../../../../utils/enums";
import { handleAllErrors } from "../../../../../../utils/methods/handleErrors";
import { formatSort } from "../../utils/constants";

export default function Main() {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const { filter, service, inputMain: { input, setInput }, item } = useTimeConfigContext()
    const [loadings, setLoadings] = useState({ table: false })
    const styles = useStyles()
    const [page, setPage] = useState(0)
    const [row, setRow] = useState<RowTable[]>([])
    const handleMenu: BaseMenuClick = (item, payload) => {
        switch (item.value as MenuType) {
            case MenuType.EDIT: {
                goForm({ id: payload?.id })
                break
            }
            case MenuType.DELETE: {
                emitEvent(Events.modal, {
                    open: true,
                    title: t('general.serviceTime.time.main.action.title') ?? '',
                    description: '',
                    cancel: (payload) => {
                        payload?.close()
                    },
                    confirm: async (value) => {
                        if (!payload?.id) {
                            value?.close()
                            return
                        }
                        emitEvent(Events.modal_extra, { loading: true })
                        const response = await levelServiceFetch.deleteServiceLeve({ id: payload?.id })
                        emitEvent(Events.modal_extra, { loading: false })
                        const code = response?.errors?.[0]?.code
                        if (!code) {
                            emitEvent(Events.snackbar, { open: true, type: Types.SUCCESS, message: t("general.serviceTime.time.form.snackbar.delete.success") })
                            value?.close()
                            getTable()
                            return
                        }
                        emitEvent(Events.snackbar, { open: true, type: Types.ERROR, message: handleAllErrors(code, t, "general.serviceTime.time.form.snackbar.delete.error") })
                    },
                })
                break
            }
        }
    }
    const column = useColumn({ click: handleMenu })

    const getTable = async () => {
        setLoadings(prev => ({ ...prev, table: true }))
        const { format, data } = await levelServiceFetch.getServiceLevel({ query: returnQuery(filter.query, formatSort) })
        setLoadings(prev => ({ ...prev, table: false }))
        if (data.errors) { return }
        setRow(format ?? [])
        setPage(data.totalPages ?? 0)
    }

    const goForm = ({ id = '' }: { id?: string }) => {
        const path = `/${PathsEnum.Service.TimeConfig}/form`
        navigate(`${path}/${id}`)
    }

    useLayoutEffect(() => {
        service.getAreasService()
        service.getDepartmentService()
    }, [])

    useEffect(() => {
        setInput(prev => ({ ...prev, areas: { ...prev.areas, items: item.areas } }))
    }, [item.areas])

    useEffect(() => {
        getTable()
    }, [filter.query.all])
    return (
        <>
            <Box className="main-container">
                <BreadCrumb
                    removeBreadcrumb={['report-folio']}
                />

                <Box sx={styles.header}>
                    <Typography variant="title_grey_big">{t('general.serviceTime.time.main.title')}</Typography>

                    <Box>
                        {!!filter?.counter && <IconButton onClick={filter.cleanFilter} sx={styles.icon}>{icons('clean')}</IconButton>}
                        <Tooltip title={t('ToolTips.create')}>
                            <IconButton onClick={() => { goForm({}) }} className='icon-size blue' sx={styles.icon}>{icons('add')}</IconButton>                        
                        </Tooltip>
                    </Box>
                </Box>

                <CustomTable
                    order={
                        filter.query?.sort && {
                            count: filter.query?.sort?.count,
                            key: filter.query?.sort?.field,
                            order: filter.query?.sort?.sort,
                        }
                    }
                    sortable={(field, sort, count) => {
                        filter.sortTable(field && sort ? { field: field, sort: sort, count } : undefined)
                    }}
                    serverSidePagination={{
                        page: (filter.paginationModel.page ?? 0) + 1,
                        size: filter.paginationModel?.pageSize ?? 20,
                        totalPages: page,
                    }}
                    handleChange={(page: number, pageSize: number) => {
                        filter.handlePagination({ page, pageSize })
                    }}
                    column={column}
                    row={row}
                    selected={-1}
                    loader={loadings.table}
                />
            </Box>

            <FloatFilter
                cleanFilter={filter.cleanFilter}
                counter={filter.counter}
                onChange={filter.onChange}
                values={filter.filterData}
                input={input}
                filter
            />
        </>
    )
}